import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  textarea: {
    '& textarea': { height: 'unset !important' },
  },
  checkChangesContainer: {
    marginTop: '27px',
    columnGap: '19px',
  },
  checkChanges: {
    padding: '0px',
  },
  emailRecipientsReportsLabel: {
    color: theme.evPalette.charcoal[900],
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  emailRecipientsReportsSubLabel: {
    color: theme.evPalette.charcoal[700],
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0px',
  },
  emailRecipientsHelpLabel: {
    color: theme.evPalette.charcoal[700],
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  editContactInfo: {
    color: '#007CAD !important',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    textDecoration: 'none',
  },
  emailInput: {
    width: '100%',
    '@media (min-width: 640px)': {
      width: '60%',
    },
  },
  emailInputRoot: {
    height: 'unset',
    '&.error fieldset': { border: `1px solid ${theme.evPalette.rose[900]} !important` },
  },
  emailInputTag: {
    '&.error': { backgroundColor: theme.evPalette.rose[100] },
  },
  tagDeleteIcon: {
    width: '16px',
    color: theme.evPalette.charcoal[600],
    '&.error': { color: theme.evPalette.rose[900] },
  },
  invalidEmail: {
    color: theme.evPalette.rose[900],
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
  },
  structureTypeTitle: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    fontStyle: 'normal',
  },
  measurementInstructionContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '24px',
    gap: '16px',
    '& .myev-MuiCheckbox-root': {
      marginLeft: '-9px',
    },
  },
  measurementInstructionCB: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 'fit-content',
    gap: '8px',
    '&.hide': {
      display: 'none',
    },
  },
  productSelectionMesurementCB: {
    color: theme.evPalette.charcoal[800],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
    margin: 'auto 0px',
  },
}));
